
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import ApiIntegrationPage from "@/pages/api-integration/ApiIntegrationPage";

export function ApiIntegrationRoutes() {
  return (
    <Route 
      path="/admin/api-integration" 
      element={
        <ProtectedRoute>
          <ApiIntegrationPage />
        </ProtectedRoute>
      } 
    />
  );
}
